<template>
  <div class="van-tabs-content item2">
    <div class="item2-content-box">
      <div class="item2-content-card">
        <div class="day-style" :class="language">{{ $t("personal.item2.go") }}</div>
        <div class="card">
          <div class="address">
            <div class="from">{{ arrivalInfo.realDeparturePlace }}</div>
            <div class="date">{{
              language === 'zh'
              ? checkDate(arrivalInfo.realDepartureTime)
              : checkDateEn(arrivalInfo.realDepartureTime)
            }}</div>
            <div class="to">{{ arrivalInfo.realArrivalPlace }}</div>
          </div>
          <div class="time">
            <div class="from">{{ checkTime(arrivalInfo.realDepartureTime) }}</div>
            <div class="date" :class="travelWayClass[chineseDict.travelWayA[arrivalInfo.realTravelWay]]">
            </div>
            <div class="to">{{ checkTime(arrivalInfo.realArrivalTime) }}</div>
            <div class="add-num">{{ checkChange(arrivalInfo.realDepartureTime, arrivalInfo.realArrivalTime) }}</div>
          </div>
          <!-- <div class="position">
            <div class="from">北京机场</div>
            <div class="to">广州白云国际机场</div>
          </div> -->
          <div class="bottom">
            <img :src="travelWayImg[chineseDict.travelWayA[arrivalInfo.realTravelWay]]" alt="" />
            <!-- <div class="name">海南航空</div> -->
            <div class="classes">{{ arrivalInfo.realFlight }}</div>
          </div>
        </div>
        <div class="left-style">
          <div class="circular"></div>
          <div class="line"></div>
        </div>
      </div>
      <div class="item2-content-card">
        <div class="day-style" :class="language">{{ $t("personal.item2.back") }}</div>
        <div class="card">
          <div class="address">
            <div class="from">{{ leaveInfo.realDeparturePlace }}</div>
            <div class="date">{{
              language === 'zh'
              ? checkDate(leaveInfo.realDepartureTime)
              : checkDateEn(leaveInfo.realDepartureTime)
            }}</div>
            <div class="to">{{ leaveInfo.realArrivalPlace }}</div>
          </div>
          <div class="time">
            <div class="from">{{ checkTime(leaveInfo.realDepartureTime) }}</div>
            <div class="date" :class="travelWayClass[chineseDict.travelWayL[leaveInfo.realTravelWay]]"></div>
            <div class="to">{{ checkTime(leaveInfo.realArrivalTime) }}</div>
            <div class="add-num">{{ checkChange(leaveInfo.realDepartureTime, leaveInfo.realArrivalTime) }}</div>
          </div>
          <!-- <div class="position">
            <div class="from">北京机场</div>
            <div class="to">广州白云国际机场</div>
          </div> -->
          <div class="bottom">
            <img :src="travelWayImg[chineseDict.travelWayL[leaveInfo.realTravelWay]]" alt="" />
            <!-- <div class="name">高铁</div> -->
            <div class="classes">{{ leaveInfo.realFlight }}</div>
          </div>
        </div>
        <div class="left-style">
          <div class="circular"></div>
          <div class="line"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getArrivalInfo, getLeaveInfo } from '@/api/guest'
import { getDictSelArr } from '@/api/dict'
import { getStatusObj, getStatusObjTwo } from '@/utils/common-config'
import IcAir from '@/assets/img/ic_air.png'
import IcGaotie from '@/assets/img/ic_gaotie.png'
export default {
  name: "TrafficInfo",
  data() {
    return {
      language: 'zh',
      arrivalInfo: {},
      leaveInfo: {},
      dict: {
        travelWayA: {},
        travelWayL: {}
      },
      chineseDict: {
        travelWayA: {},
        travelWayL: {}
      },
      travelWayClass: {
        飞机: 'plane',
        火车: 'train',
        高铁: 'train'
      },
      travelWayImg: {
        飞机: IcAir,
        火车: IcGaotie,
        高铁: IcGaotie,
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.language = this.$i18n.locale
      this.getArrivalInfo()
      this.getLeaveInfo()
      this.getDictSelArr()
    },
    getArrivalInfo() {
      getArrivalInfo().then(res => {
        this.arrivalInfo = res.data
      })
    },
    getLeaveInfo() {
      getLeaveInfo().then(res => {
        this.leaveInfo = res.data
      })
    },
    getDictSelArr() {
      getDictSelArr({ conferenceId: this.$route.params.conferenceId, codes: 'arrival_travel_way,leave_travel_way,accommodation_mode' }).then(res => {
        if (Object.hasOwnProperty.call(res.data, 'arrival_travel_way')) {
          this.dict.travelWayA = getStatusObjTwo(this.$t3, res.data.arrival_travel_way, 'code', 'name', 'nameEn')
          this.chineseDict.travelWayA = getStatusObj(res.data.arrival_travel_way, 'code', 'name')
        }
        if (Object.hasOwnProperty.call(res.data, 'leave_travel_way')) {
          this.dict.travelWayL = getStatusObjTwo(this.$t3, res.data.leave_travel_way, 'code', 'name', 'nameEn')
          this.chineseDict.travelWayL = getStatusObj(res.data.leave_travel_way, 'code', 'name')
        }
      })
    },
    checkDate(datetime) {
      if (!datetime) {
        return ''
      }
      const month = parseInt(datetime.substring(5, 7))
      const day = parseInt(datetime.substring(8, 10))
      return month + '月' + day + '日'
    },
    checkDateEn(datetime) {
      if (!datetime) {
        return ''
      }
      const month = datetime.substring(5, 7)
      const day = datetime.substring(8, 10)
      return month + '.' + day
    },
    checkTime(datetime) {
      if (!datetime) {
        return ''
      }
      return datetime.substring(11, 16)
    },
    checkChange(start, end) {
      if (!start || !end) {
        return ''
      }
      const startTime = new Date(start.replace(/-/g, '/'))
      const endTime = new Date(end.replace(/-/g, '/'))
      startTime.setHours(0, 0, 0, 0)
      endTime.setHours(0, 0, 0, 0)
      const day = (endTime - startTime) / 86400000
      if (day === 0) {
        return ''
      }
      if (day > 0) {
        return '+' + day
      }
      return day
    }
  }
};
</script>

<style lang="scss" scoped>
.van-tabs-content {
  margin: 20px 0 0;

  &.item2 {
    .item2-content-box {
      .day-style {
        margin: 0 0 8px;
        // width: 53px;
        height: 21px;
        padding-left: 11px;
        font-size: 12px;
        font-weight: 500;
        color: #fff;
        line-height: 23px;
        text-align: left;
        background: url(~@/assets/img/tag_bg_green.png) no-repeat;
        background-size: contain;
        box-sizing: border-box;

        &.en {
          background: url(~@/assets/img/tag_bg_green_en.png) no-repeat;
          background-size: contain;
        }
      }

      .item2-content-card {
        margin: 0 0 5px;
        position: relative;
        padding-left: 20px;
        padding-bottom: 15px;

        &:last-child {
          .left-style {
            .line {
              display: none;
            }

            .circular {
              background: url("~@/assets/img/ic_circular_blue.png") center no-repeat;
              background-size: contain;
            }
          }

        }

        .card {
          padding: 20px 20px 0;
          height: 137px;
          width: 326px;
          box-sizing: border-box;
          background: url("~@/assets/img/card_img.png") center no-repeat;
          background-size: 100% 100%;

          .address {
            position: relative;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .from,
            .to {
              font-size: 14px;
              font-weight: 400;
              color: rgba($color: #fff, $alpha: 0.8);
              line-height: 20px;
            }

            .date {
              font-size: 12px;
              font-weight: 400;
              color: rgba($color: #fff, $alpha: 0.8);
              line-height: 20px;
            }
          }

          .time {
            margin: 2px 0 0;
            position: relative;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .from,
            .to {
              font-size: 24px;
              font-weight: bold;
              color: rgba($color: #fff, $alpha: 1);
              line-height: 29px;
            }

            .date {
              width: 117px;
              height: 25px;
              background: url("~@/assets/img/air_img.png");
              background-size: contain;

              &.plane {
                background: url("~@/assets/img/air_img.png");
                background-size: contain;
              }

              &.train {
                background: url("~@/assets/img/high-speed_img.png");
                background-size: contain;
              }
            }

            .add-num {
              position: absolute;
              right: -14px;
              top: -3px;
              font-size: 12px;
              color: #1debff;
              line-height: 14px;
            }
          }

          .position {
            position: relative;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .from,
            .to {
              font-size: 12px;
              font-weight: 400;
              color: rgba($color: #fff, $alpha: 0.8);
              line-height: 20px;
            }
          }

          .bottom {
            display: flex;
            flex-direction: row;
            align-items: center;
            height: 44px;
            margin: 20px 0 0;

            img {
              display: block;
              width: 17px;
              height: 17px;
              object-fit: contain;
            }

            .name {
              margin-left: 8px;
              font-size: 13px;
              font-weight: 500;
              color: rgba($color: #fff, $alpha: 0.8);
            }

            .classes {
              margin-left: 4px;
              font-size: 13px;
              font-weight: bold;
              color: rgba($color: #fff, $alpha: 0.8);
            }
          }
        }

        .left-style {
          position: absolute;
          left: 0;
          top: 2px;
          bottom: 0;

          .circular {
            position: relative;
            width: 14px;
            height: 14px;
            background: url("~@/assets/img/ic_circular_green.png") center no-repeat;
            background-size: contain;
          }

          .line {
            width: 1px;
            margin: 8px auto 0;
            height: calc(100% - 22px);
            background-image: linear-gradient(to bottom,
                #3eb134 0%,
                #3eb134 10%,
                transparent 20%);
            background-size: 1px 10px;
            background-repeat: y-repeat;
          }
        }

        &:nth-child(2) {
          .day-style {
            background: url(~@/assets/img/tag_bg_blue.png) no-repeat;
            background-size: contain;

            &.en {
              background: url(~@/assets/img/tag_bg_blue_en.png) no-repeat;
              background-size: contain;
            }
          }
        }
      }
    }
  }
}
</style>
